/* eslint-disable camelcase */
import Vue from 'vue'
// import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null
// let token = this.getters['auth/getCurrentUser'].token;
export const state = {
  objects: {},
}

export const getters = {
}

export const mutations = {
  SET_CLIENTSDATA(state, objects) {
    let updatedObjects = {}

    for (let key in objects) {

      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[key] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
    // // console.log(state.objects)

  },
  SET_CLIENT(state, objects) {
      state.currentClient = objects
  },
  SET_ALLCLIENTSDATA(state, objects) {
    let updatedObjects = {}

    for (let key in objects) {

      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[key] = objects[key]
      } else if (state.allobjects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.allobjects, objects[key].id)
      }
    }
    state.allobjects = {
      ...updatedObjects,
    }
    // // console.log(state.objects)

  },
  SET_ALLCLIENT(state, objects) {
      state.currentAllClient = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },

  async getClientCollectionData({ commit }) {
      try {
        const gql = require( 'graphql-tag');
        let token = JSON.stringify(this.getters['auth/getCurrentUser'].token);
          const response = await
              graphqlClient.query({
                  query: gql`
                  query{
                    clientcollections(token:${token}){
                      wasteTypes{
                          text
                          value
                        }
                        collectionsBreakdown {
                          count
                          amount
                          type
                          service
                        }
                        collections{
                          collection
                        }
              					ytdweight {
              					  name
              					  jan
              					  feb
              					  mar
              					  apr
              					  may
              					  jun
              					  jul
              					  aug
              					  sep
              					  oct
              					  nov
              					  dec
              					}
                        ytdmonthlytotals {
                          name
                          jan
                          feb
                          mar
                          apr
                          may
                          jun
                          jul
                          aug
                          sep
                          oct
                          nov
                          dec
                        }
                    }
                  }
                  `,
              })
          commit('SET_CLIENTSDATA', response.data.clientcollections)
          // // console.log(response)
      } catch (ex) {
          console.error(ex)
          throw ex
      }
  },
  async getClientCollectionDataById({ commit }, { id } = {}) {
    try {
      const gql = require( 'graphql-tag');
      await
        graphqlClient.query({
          query: gql`
            query{
              clientCollectionsById(id:${id}){
                wasteTypes{
                    text
                    value
                  }
                  collectionsBreakdown {
                    count
                    amount
                    type
                    service
                  }
                  collections{
                    collection
                  }
                  ytdweight {
                    name
                    jan
                    feb
                    mar
                    apr
                    may
                    jun
                    jul
                    aug
                    sep
                    oct
                    nov
                    dec
                  }
                  ytdmonthlytotals {
                    name
                    jan
                    feb
                    mar
                    apr
                    may
                    jun
                    jul
                    aug
                    sep
                    oct
                    nov
                    dec
                  }
              }
            }
            `,
        }).then((response) => {
          // console.log(response)
          commit('SET_CLIENTSDATA', response.data.clientCollectionsById)
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getAllCollectionData({ commit }) {

      try {
        const gql = require( 'graphql-tag');

          const response = await
              graphqlClient.query({
                  query: gql`
                  query{
                    allcollections{
                      wasteTypes{
                          text
                          value
                        }
                        collectionsBreakdown {
                          count
                          amount
                          type
                          service
                        }
                        collections{
                          collection
                        }
                        ytdweight {
                          name
                          jan
                          feb
                          mar
                          apr
                          may
                          jun
                          jul
                          aug
                          sep
                          oct
                          nov
                          dec
                        }
                        ytdmonthlytotals {
                          name
                          jan
                          feb
                          mar
                          apr
                          may
                          jun
                          jul
                          aug
                          sep
                          oct
                          nov
                          dec
                        }
                    }
                  }
                  `,
              })
          commit('SET_ALLCLIENTSDATA', response.data.allcollections)

      } catch (ex) {
          console.error(ex)
          throw ex
      }
  },


}
